import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-associata-box',
  templateUrl: './associata-box.component.html',
  styleUrls: ['./associata-box.component.css']
})
export class AssociataBoxComponent {

  getCostoTipovisita(tipovisita): number {
    const przVisita = parseFloat(tipovisita.costoDefault);
    let przOk = 0;
    if (przVisita > 0) {
      przOk = przVisita;
    } else {
      przOk = parseFloat(tipovisita.costoDefault);
    }
    return przOk;
  }

  getCostoTipovisitaScontato(tipovisita, valore): number {
    const przVisita = parseFloat(tipovisita.costoMax);
    let przOk = 0;
    if (przVisita > 0) {
      przOk = przVisita;
    } else {
      przOk = parseFloat(tipovisita.costoDefault);
    }
    przOk = przOk - (przOk / 100 * valore);
    return przOk;
  }

  @Input() tvAssociata: any;
  tvSelezionata = null;
  @Output() reset = new EventEmitter<any>();
  @Output() set = new EventEmitter<any>();

  constructor() {

  }

  setta() {
    this.tvSelezionata = this.tvAssociata;
    return this.set.emit(this.tvSelezionata);
  }

  resetta() {
    this.tvSelezionata = null;
    return this.reset.emit();
  }
}
